import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/illustrations/placeholders/flat/placeholder-search-4.svg")